import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';
import ProductOffer from './ProductOffer/ProductOffer.js';

const ProductOffers = (_param)=>{
    var { className , labels , offers , fallbackImage , linkTarget  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "offers",
        "fallbackImage",
        "linkTarget"
    ]);
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('product-offers', className)
    }), /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h3"
    }, labels.title), /*#__PURE__*/ React.createElement("div", {
        className: "product-offers__items"
    }, offers.map(({ title , description , url , imageUrl  })=>/*#__PURE__*/ React.createElement(ProductOffer, {
            key: title,
            className: "product-offers__offer",
            title: title,
            description: description,
            url: url,
            imageUrl: imageUrl,
            fallbackImageUrl: fallbackImage,
            linkTarget: linkTarget
        })
    )));
};

export { ProductOffers as default };
//# sourceMappingURL=ProductOffers.js.map
